<template>
  <div class="home-page">
    <HeroSection />
    
    <section id="features" class="scroll-mt-20">
      <Features />
    </section>
    
    <section id="partners" class="scroll-mt-20">
      <PartnersSection />
    </section>
    
    <!-- <section id="how-it-works" class="scroll-mt-20">
      <Testimonials />
    </section> -->
    
    <!-- <section id="pricing" class="scroll-mt-20">
      <Pricing />
    </section> -->
  </div>
</template>

<script setup lang="ts">
import { defineComponent } from 'vue'
import HeroSection from '@/components/HeroSection.vue'
import Features from '@/components/FeatureSection.vue'
import PartnersSection from '@/components/PartnersSection.vue'
// import Testimonials from '@/components/TestimonialSection.vue'
// import Pricing from '@/components/PricingSection.vue'

// Ensure components are registered
defineComponent({
  components: {
    HeroSection,
    Features,
    PartnersSection,
    // Testimonials,
    // Pricing
  }
})
</script>

<style scoped>
.home-page {
  @apply min-h-screen;
}
</style>